import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	checkboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	selectAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deselectAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	link: {
		id: 'ai-related-issues.related-issues-draft-list.link',
		defaultMessage: 'Link',
		description: 'Text for button used to link related issue',
	},
	checkboxLabel: {
		id: 'ai-related-issues.related-issues-draft-list.checkbox-label',
		defaultMessage: '{issueLabel}',
		description: 'Aria label for checkboxes used to link related issue',
	},
	selectAll: {
		id: 'ai-related-issues.related-issues-draft-list.select-all',
		defaultMessage: 'Select all',
		description: 'Text for checkbox used to select all the ai provided suggestions',
	},
	deselectAll: {
		id: 'ai-related-issues.related-issues-draft-list.deselect-all',
		defaultMessage: 'Deselect all',
		description: 'Text for checkbox used to deselect all the ai provided suggestions',
	},
});
export default messages;
